import Immutable from 'immutable';
import type { Map } from 'immutable';
import type { AnyAction } from 'redux';
import {
  LOAD_DEFINITIONS,
  LOAD_MAPPINGS,
  LOAD_RULES,
  SAVE_DEFINITIONS,
  SAVE_MAPPINGS,
  SAVE_RULES,
} from './actions';

const initialState = Immutable.fromJS({
  inputs: [],
  sets: [],
  mappings: {},
  rules: [],
  UIStates: {
    loadingDefinitions: true,
    loadingMappings: true,
    loadingRules: true,
    savingDefinitions: false,
    savingMappings: false,
    savingRules: false,
  },
});

function fuzzyReducer(
  state: Map<string, unknown> = initialState,
  action: AnyAction,
): Map<string, unknown> {
  switch (action.type) {
    case `${SAVE_DEFINITIONS}_LOADING`: {
      return state.setIn(['UIStates', 'savingDefinitions'], true);
    }
    case `${SAVE_DEFINITIONS}_ERROR`: {
      return state.setIn(['UIStates', 'savingDefinitions'], false);
    }
    case SAVE_DEFINITIONS: {
      return state
        .merge(
          Immutable.fromJS({
            inputs: action.definitions.inputs,
            sets: action.definitions.sets,
          }),
        )
        .setIn(['UIStates', 'savingDefinitions'], false);
    }
    case `${SAVE_MAPPINGS}_LOADING`: {
      return state.setIn(['UIStates', 'savingMappings'], true);
    }
    case `${SAVE_MAPPINGS}_ERROR`:
    case SAVE_MAPPINGS: {
      return state.setIn(['UIStates', 'savingMappings'], false);
    }
    case `${SAVE_RULES}_LOADING`: {
      return state.setIn(['UIStates', 'savingRules'], true);
    }
    case `${SAVE_RULES}_ERROR`:
    case SAVE_RULES: {
      return state.setIn(['UIStates', 'savingRules'], false);
    }
    case `${LOAD_DEFINITIONS}_LOADING`: {
      return state
        .merge(
          Immutable.fromJS({
            inputs: [],
            sets: [],
          }),
        )
        .setIn(['UIStates', 'loadingDefinitions'], true);
    }
    case `${LOAD_DEFINITIONS}_ERROR`: {
      return state
        .merge(
          Immutable.fromJS({
            inputs: [],
            sets: [],
          }),
        )
        .setIn(['UIStates', 'loadingDefinitions'], false);
    }
    case LOAD_DEFINITIONS: {
      return state
        .merge(
          Immutable.fromJS({
            inputs: action.data.data.inputs || [],
            sets: action.data.data.sets || [],
          }),
        )
        .setIn(['UIStates', 'loadingDefinitions'], false);
    }
    case `${LOAD_MAPPINGS}_LOADING`: {
      return state
        .merge(Immutable.fromJS({ mappings: {} }))
        .setIn(['UIStates', 'loadingMappings'], true);
    }
    case `${LOAD_MAPPINGS}_ERROR`: {
      return state
        .merge(Immutable.fromJS({ mappings: {} }))
        .setIn(['UIStates', 'loadingMappings'], false);
    }
    case LOAD_MAPPINGS: {
      return state
        .merge(Immutable.fromJS({ mappings: action.data.data || {} }))
        .setIn(['UIStates', 'loadingMappings'], false);
    }
    case `${LOAD_RULES}_LOADING`: {
      return state
        .merge(Immutable.fromJS({ rules: [] }))
        .setIn(['UIStates', 'loadingRules'], true);
    }
    case `${LOAD_RULES}_ERROR`: {
      return state
        .merge(Immutable.fromJS({ rules: [] }))
        .setIn(['UIStates', 'loadingRules'], false);
    }
    case LOAD_RULES: {
      return state
        .merge(Immutable.fromJS({ rules: action.data.data || [] }))
        .setIn(['UIStates', 'loadingRules'], false);
    }
    default: {
      return state;
    }
  }
}

export default fuzzyReducer;
